(function () {
  'use strict';

  if (window.ShopifyWishlist) return;

  const STORAGE_KEY = 'shopify_custom_wishlist_v1';

  function normalizeId(value) {
    return String(value || '').trim();
  }

  function getItems() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);

      if (!saved) return [];

      const items = JSON.parse(saved);

      return Array.isArray(items) ? items : [];
    } catch (error) {
      console.warn('[Wishlist] Failed to read wishlist:', error);
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );

      window.dispatchEvent(
        new CustomEvent('wishlist:updated', {
          detail: {
            items: items,
            count: items.length
          }
        })
      );

      return true;
    } catch (error) {
      console.warn('[Wishlist] Failed to save wishlist:', error);
      return false;
    }
  }

  function getProductFromButton(button) {
    return {
      id: normalizeId(button.dataset.productId),

      variantId: normalizeId(
        button.dataset.variantId
      ),

      handle:
        button.dataset.productHandle || '',

      title:
        button.dataset.productTitle || '',

      url:
        button.dataset.productUrl || '',

      image:
        button.dataset.productImage || '',

      price:
        Number(button.dataset.productPrice || 0),

      addedAt:
        new Date().toISOString()
    };
  }

  function contains(productId) {
    const id = normalizeId(productId);

    if (!id) return false;

    return getItems().some(function (item) {
      return normalizeId(item.id) === id;
    });
  }

  function updateButton(button) {
    if (!button) return;

    const id = normalizeId(
      button.dataset.productId
    );

    if (!id) return;

    const active = contains(id);

    button.classList.toggle(
      'is-active',
      active
    );

    button.setAttribute(
      'aria-pressed',
      active ? 'true' : 'false'
    );

    const productTitle =
      button.dataset.productTitle || 'Product';

    if (active) {
      button.setAttribute(
        'aria-label',
        'Remove ' +
          productTitle +
          ' from wishlist'
      );

      button.setAttribute(
        'title',
        'Remove from wishlist'
      );
    } else {
      button.setAttribute(
        'aria-label',
        'Add ' +
          productTitle +
          ' to wishlist'
      );

      button.setAttribute(
        'title',
        'Add to wishlist'
      );
    }
  }

  function refreshButtons(root) {
    root = root || document;

    root
      .querySelectorAll(
        '[data-wishlist-button]'
      )
      .forEach(function (button) {
        updateButton(button);
      });
  }

  function refreshCounts() {
    const count = getItems().length;

    document
      .querySelectorAll(
        '[data-wishlist-count]'
      )
      .forEach(function (element) {
        element.textContent = count;

        element.hidden = count === 0;
      });
  }

  function add(product) {
    if (!product || !product.id) {
      return false;
    }

    const items = getItems();

    const exists = items.some(
      function (item) {
        return (
          normalizeId(item.id) ===
          normalizeId(product.id)
        );
      }
    );

    if (exists) return false;

    items.push(product);

    if (!saveItems(items)) {
      return false;
    }

    refreshButtons();
    refreshCounts();

    return true;
  }

  function remove(productId) {
    const id = normalizeId(productId);

    if (!id) return false;

    const items = getItems().filter(
      function (item) {
        return (
          normalizeId(item.id) !== id
        );
      }
    );

    if (!saveItems(items)) {
      return false;
    }

    refreshButtons();
    refreshCounts();

    return true;
  }

  function toggle(product) {
    if (!product || !product.id) {
      return false;
    }

    if (contains(product.id)) {
      remove(product.id);

      return false;
    }

    add(product);

    return true;
  }

  function handleButton(button) {
    const product =
      getProductFromButton(button);

    if (!product.id) {
      console.warn(
        '[Wishlist] Missing product ID.'
      );

      return;
    }

    const added = toggle(product);

    updateButton(button);

    const status =
      button.querySelector(
        '[data-wishlist-status]'
      );

    if (status) {
      status.textContent = added
        ? product.title +
          ' added to wishlist'
        : product.title +
          ' removed from wishlist';

      window.setTimeout(function () {
        status.textContent = '';
      }, 2000);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      const button =
        event.target.closest(
          '[data-wishlist-button]'
        );

      if (!button) return;

      event.preventDefault();
      event.stopPropagation();

      handleButton(button);
    }
  );

  function init() {
    refreshButtons();
    refreshCounts();
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      refreshButtons(event.target);
      refreshCounts();
    }
  );

  window.addEventListener(
    'storage',
    function (event) {
      if (event.key !== STORAGE_KEY) {
        return;
      }

      refreshButtons();
      refreshCounts();
    }
  );

  window.addEventListener(
    'wishlist:refresh',
    function () {
      refreshButtons();
      refreshCounts();
    }
  );

  window.ShopifyWishlist = {
    getItems: getItems,
    saveItems: saveItems,
    contains: contains,
    add: add,
    remove: remove,
    toggle: toggle,
    refresh: function () {
      refreshButtons();
      refreshCounts();
    }
  };
})();